  
 

  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>link</mat-icon></span>
    Map documents with Placeholders 
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>    
  </h2>
  
<mat-dialog-content class="mat-typography">
  <div class="block mt-10">
    <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCCC($event)">
      <mat-radio-button value="Core" [checked]="checkedAttachCore">{{CoreShowName}}</mat-radio-button> &nbsp;&nbsp;
      <mat-radio-button value="Contact" [checked]="checkedAttachContact">{{ContactShowName}}</mat-radio-button>
    </mat-radio-group>
  </div>
  
  <div class="block mt-10" *ngIf="ShowAttchedToCore">
    <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
      <mat-label>Search {{CoreShowName}}</mat-label>
      <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
        (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option (click)="attchedToCoreSelected(core)" *ngFor="let core of attachedToCoreList"
          [value]="core.name">
          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="userpic">
              <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
              <span class="username" *ngIf="core.imageUrl==''" class="username">
                {{core.shortName}}
              </span>
            </div>
            <div class="info">
              <p> {{ core.name }}</p>
              <p class="email">{{ core.email }}</p>
            </div>
          </span>
        </mat-option>
      </mat-autocomplete>

    </mat-form-field>
    <ul class="selectedlist" *ngFor="let core of attachedToSelectedCore">
      <li *ngIf="!core.isDeleted">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="core.img!=''" src="{{core.img}}" alt="">
            <span *ngIf="core.img==''" class="username">
              {{core.shortName}}
            </span>
          </div>
          <div class="details">
            <h4>{{core.name}}</h4>
            <p>{{core.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="attchedToRemoveCore(core)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="block mt-10" *ngIf="ShowAttchedToContact">
    <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
      <mat-label>Search {{ContactShowName}}</mat-label>
      <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
        (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option (click)="attchedToContactSelected(contact)"
          *ngFor="let contact of attachedToContactList" [value]="contact.name">
          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="userpic">
              <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
              <span class="username" *ngIf="contact.imageUrl==''" class="username">
                {{contact.shortName}}
              </span>
            </div>
            <div class="info">
              <p> {{ contact.name }}</p>
              <p class="email">{{ contact.email }}</p>
            </div>
          </span>
        </mat-option>
      </mat-autocomplete>

    </mat-form-field>
    <ul class="selectedlist" *ngFor="let contact of attachedToSelectedContact">
      <li *ngIf="!contact.isDeleted">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
            <span *ngIf="contact.img==''" class="username">
              {{contact.shortName}}
            </span>
          </div>
          <div class="details">
            <h4>{{contact.name}}</h4>
            <p>{{contact.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="attchedToRemoveContact(contact)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>

 <p *ngIf="showMessage==true" style="color: red;">
  This email is not currently registered as a {{CoreShowName}}. Please proceed with adding this email to the {{CoreShowName}} records from {{CoreShowName}} module.
 </p>
  

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary"   [disabled]="showSaveButton==true"
  (click)="addUpdateFolderUrl()">Add
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>

<!-- [disabled]="showSaveButton==true" -->








